import axios from "axios";

// Create an Axios instance
const httpcommon = axios.create({
    baseURL: import.meta.env.VITE_API_BASE_URL, // Read from environment variable
    headers: {
        "Content-Type": "application/json",
    },
});

// Add a request interceptor to attach token
httpcommon.interceptors.request.use(
    (config) => {
        const user = JSON.parse(localStorage.getItem("login-user")); // Parse stored user data
        const token = user?.token; // Get token
        if (token) {
            config.headers.Authorization = `Bearer ${token}`; // Add token to headers
        }
        return config;
    },
    (error) => Promise.reject(error)
);

// Add a response interceptor to handle 401 errors
httpcommon.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response && error.response.status === 401) {
            const user = JSON.parse(localStorage.getItem("login-user"));
            const loginPath = user?.role === "Parent" ? "/parent-portal/login" : "/login";
            localStorage.removeItem("login-user"); // Remove token from storage
            window.location.href = loginPath; // Redirect to login page
        }
        return Promise.reject(error);
    }
);

export default httpcommon;
